import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputNumberPositiveErrorMessage = (
  <Trans>Ce champ doit être positif</Trans>
);
